import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {Stack} from '@salesforce/retail-react-app/app/components/shared/ui'

import PDComponent from '../../pd-component'
import Schema from './partials/schema'
import usePdTagManager from '../../../../hooks/use-pd-tag-manager'

export const Testimonials = ({regions, product, typeId, name}) => {
    const pdTagManager = usePdTagManager()
    const totalItems = regions.reduce((total, item) => total + (item.components?.length || 0), 0)
    useEffect(() => {
        pdTagManager.viewComponent(typeId, name, totalItems)
    }, [])
    return (
        <Stack
            align={{base: 'center', md: 'start'}}
            flexDirection={{base: 'column', md: 'row'}}
            justify="center"
            spacing={{base: '40px', md: '20px', lg: '40px'}}
            marginTop="20px"
            marginBottom="20px"
            paddingX={{base: '15px', lg: '18px', '2xl': '43px'}}
        >
            <Schema regions={regions} product={product} />
            {regions?.map((region) =>
                region?.components?.map((component, index) => (
                    <PDComponent
                        key={`${region.id}-${index}`}
                        totalItems={totalItems}
                        component={component}
                    />
                ))
            )}
        </Stack>
    )
}

Testimonials.propTypes = {
    regions: PropTypes.array,
    name: PropTypes.any,
    typeId: PropTypes.string,
    product: PropTypes.object
}

export default Testimonials
